// Module
var code = "<p>אם שכחתם את הסיסמא תוכלו לשחזר אותה באמצעות כתובת המייל שלכם. אנחנו נשלח לכם מייל סיוע.</p> ";
// Exports
export default code;